// Generated by ReScript, PLEASE EDIT WITH CARE

import NitroBotAnchorBindJs from "./NitroBotAnchor.bind.js";

var make = NitroBotAnchorBindJs;

export {
  make ,
  
}
/* make Not a pure module */
